import {
    enum_fbPath, enum_fileType, enum_iframeMsg, enum_moveToOptions, enum_projectEnv_s,
    enum_questTicketActions,
    enum_questTicketStatus,
    enum_reportReviewStatus_e, enum_saleType_n
} from "../../../functions/src/shareCode/Share_S_Enum";

import {date_newDate_fd} from "../S_Date";
import {gv_urls} from "@/scripts/S_GlobalVar";
import {
    obj_map_fo,
    obj_size_fn, obj_toArray_fo,
} from "../../../functions/src/shareCode/Share_S_Obj";
import {helper_calculateSum_n, helper_getTicketUrl, helper_prevString_s,} from "../S_Helper";
import {
    FB_File,
    FB_QuestDiscountCoupon,
    FB_QuestEvent,
    FB_QuestReview,
    FB_QuestTicket,
    FB_QuestTicket_History,
    FB_UDS_QuestTicketPointer,
    FB_TicketShortKey,
    FB_UserDataSub_CreatorPaymentInfo,
    FB_UserDataSub_MoreInfo,
    FB_Report_Review,
    FB_UserDataSub_QuestPermission,
    FB_MoreInfo,
    FB_Error,
    FB_UserDataSub_CreditCard,
    FB_UDS_CreatorMonthlyTickets,
    FB_QuestMold,
    FB_BlogArticle,
    FB_QuestExplore_GeoHash,
    FB_QuestExplore_Info,
    FB_LastQuestReviewPointer,
    FB_UserDataSub_OnlineUser,
    FB_UserDataSub_SubscriptionPlanInfo,
    FB_ServerCurrentVersion,
    FB_QuestBackupInfo,
    FB_QuestPointer, FB_TqInfo
} from "../../../functions/src/shareCode/Share_S_Classes";
import {
    http_classSubChildName_os,
    http_database_getNewKey_f,
    http_database_onChildListener_close_f,
    http_database_onChildListener_open_f,
    http_database_onValueListener_close_f,
    http_database_onValueListener_open_f,
    http_database_setData_f,
    http_database_getOnce_f,
    http_database_transaction_f,
    http_database_updateData_f,
    http_endPointPath_oa,
    http_storage_uploadFile_f,
    http_storage_deleteFile_fp,
    http_functions_fp,
    fbRef_subRef, http_translate_fp,
} from "./S_HttpRequests";
import {date_nowTime_t} from "../../../functions/src/shareCode/Share_S_Date";
import {format_date_YYYY_MM_fs} from "../../../functions/src/shareCode/Share_S_Format";
import {gv_fun_env} from "../../../functions/src/shareCode/Share_Ass_GlobalVirables";
import {route_addLangToPath_s} from "@/router";

// =========== 0) global =============


// serverGlobal_currentVersion
export const serverGlobal_currentVersion_vl_set_f =(viewName_s, cb_f) =>{

    http_database_onValueListener_open_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PRE_CURRENT_VERSION,
        cacheFallback_b : true,
        cb_f : (data_o) => {
            cb_f(new FB_ServerCurrentVersion(data_o))
        }
    })

}
export const serverGlobal_currentVersion_vl_remove_f =(viewName_s) =>{

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PRE_CURRENT_VERSION,
    })

}
export const serverGlobal_currentVersion_update_f =(serverVersionInfo_c, cb_f) =>{

    http_database_updateData_f({
        path_as : http_endPointPath_oa.PRE_CURRENT_VERSION,
        data_c : serverVersionInfo_c,
        cb_f : cb_f,
    })

}

// =========== 1) users =============

// server_cl_currentUserTickets_get_f
export const serverPre_currentUserTickets_cl_set_f = (viewName_s, lastQuestTicketPointer_c, userId_uid, childAddedCb_f) => {

    http_database_onChildListener_open_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_QUESTS_TICKETS.concat(userId_uid),
        cacheFallback_b : true,
        query_os : {
            orderBy     : http_classSubChildName_os.qetp_orderBy_uid,
            limitToLast : 3,
            endAt       : lastQuestTicketPointer_c != null ? helper_prevString_s(lastQuestTicketPointer_c.qetp_orderBy_uid) : '99999',
        },
        cb_f : (questTicket_o, childKey_s) => {
            childAddedCb_f(new FB_UDS_QuestTicketPointer(questTicket_o))
        }
    })

}
export const serverPre_currentUserTickets_cl_remove_f = (viewName_s, lastQuestTicketPointer_c, userId_uid) => {

    http_database_onChildListener_close_f({
        viewName_s : viewName_s,
        query_os : {
            orderBy     : http_classSubChildName_os.qetp_orderBy_uid,
            limitToLast : 3,
            endAt       : lastQuestTicketPointer_c != null ? helper_prevString_s(lastQuestTicketPointer_c.qetp_orderBy_uid) : null,
        },
        path_as : http_endPointPath_oa.PUDSC_QUESTS_TICKETS.concat(userId_uid),
    })

}

// server_cl_currentUserLovedQuests_get_f
export const serverPre_cl_currentUserLovedQuests_get_f = (viewName_s, currentUserData_c, childAddedCb_f, childChangedCb_f, childRemovedCb_f) => {


    http_database_onChildListener_open_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_LOVED_QUESTS.concat(currentUserData_c.ud_userId_uid),
        cb_f    : (questPointer_o, questPointerId_uid) => {


            if(questPointer_o != null){
                childAddedCb_f(new FB_QuestPointer(questPointer_o))
            } else{
                childRemovedCb_f(questPointerId_uid)
            }
        },
    })

}
export const serverPre_cl_currentUserLovedQuests_remove_f = (viewName_s, ud_userId_uid) => {

    http_database_onChildListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_LOVED_QUESTS.concat(ud_userId_uid),
    })

}

// server_userCreatedQuests
export const serverPre_userCreatedQuests_getOnce_fp = ({userId_uid, cb_f}) =>{

    // let ref = getRef_userData_subCollection(enum_subCollection_users.CREATED_QUESTS, userId_uid)
    //
    // serverStorage2_getDataOnce_fp({
    //     key_s : "createdQuests_" + userId_uid,
    //     getServerData_pf(){
    //         return realTimeDB_setOnceListener_fp(ref)
    //     }
    // }).then(createdQuests_ao => {
    //     let createdQuests_ac =  obj_map_fo(createdQuests_ao, (questPointer_o) =>{
    //         return new FB_QuestPointer(questPointer_o)
    //     })
    //
    //     cb_f(createdQuests_ac)
    // })
    //
    // console.log('server_userCreatedQuests_getOnce_fp')


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_CREATED_QUESTS.concat(userId_uid),
        cb_f    : (createdQuests_ao) => {


            let createdQuests_ac = obj_map_fo(createdQuests_ao, (questPointer_o) =>{
                return new FB_QuestPointer(questPointer_o)
            })

            cb_f(createdQuests_ac)
        }
    })


}
export const serverPre_allUsersCreatedQuests_getOnce_fp = (cb_f) =>{

    // let ref = getRef_userData_subCollection(enum_subCollection_users.CREATED_QUESTS, userId_uid)
    //
    // serverStorage2_getDataOnce_fp({
    //     key_s : "createdQuests_" + userId_uid,
    //     getServerData_pf(){
    //         return realTimeDB_setOnceListener_fp(ref)
    //     }
    // }).then(createdQuests_ao => {
    //     let createdQuests_ac =  obj_map_fo(createdQuests_ao, (questPointer_o) =>{
    //         return new FB_QuestPointer(questPointer_o)
    //     })
    //
    //     cb_f(createdQuests_ac)
    // })
    //
    // console.log('server_userCreatedQuests_getOnce_fp')


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_CREATED_QUESTS,
        cb_f    : (createdQuests_o) => {
            cb_f(createdQuests_o)
        }
    })


}
export const server_userData_setCreatedQuests_f = (userId_uid, questsPointers_byQuestId_c, cb_f) =>{


    // let ref = getRef_userData_subCollection(enum_subCollection_users.CREATED_QUESTS, userId_uid)
    // return realTimeDB_setData(ref, questsPointers_byQuestId_c)

    http_database_setData_f({
        path_as : http_endPointPath_oa.PUDSC_CREATED_QUESTS.concat(userId_uid),
        data_c  : questsPointers_byQuestId_c,
        cb_f    : cb_f
    })

}

// serverPre_userDataSub_questPermission
export const serverPre_userDataSub_questPermission_set_f = ({questId_uid, questType_e, userId_uid, permissionLevel_n, cb_f}) => {

    let newQuestPermissions_c = new FB_UserDataSub_QuestPermission({
        udsqp_questId_uid : questId_uid,
        udsqp_questType_e : questType_e,
        udsqp_userId_uid : userId_uid,
        udsqp_permission_n : permissionLevel_n,
    })

    http_database_setData_f({
        path_as : http_endPointPath_oa.PUDSC_QUESTS_PERMISSIONS.concat(newQuestPermissions_c.udsqp_m_id_fs()),
        data_c : newQuestPermissions_c,
        cb_f : (uds_questPermission_o) => {
            cb_f(new FB_UserDataSub_QuestPermission(uds_questPermission_o))
        }
    })

}
export const serverPre_userDataSub_questPermission_get_withQuestId_f = ({questId_uid, questType_e, cb_f}) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_QUESTS_PERMISSIONS,
        query_os : {
            orderBy     : http_classSubChildName_os.udsqp_questId_uid,
            equalTo     : questId_uid,
        },
        cb_f :(uds_questPermissions_byId_o) => {


            let uds_questPermissions_ao = obj_toArray_fo(uds_questPermissions_byId_o)
            let uds_questPermissions_ac = uds_questPermissions_ao.map(uds_questPermissions_o => {return new FB_UserDataSub_QuestPermission(uds_questPermissions_o)})
            uds_questPermissions_ac = uds_questPermissions_ac.filter(uds_questPermissions_c => {return uds_questPermissions_c.udsqp_questType_e === questType_e} )

            cb_f(uds_questPermissions_ac)
        }
    })

}
export const serverPre_userDataSub_questPermission_get_withUserId_f = ({userId_uid, questMinPermission_n, cb_f}) => {


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_QUESTS_PERMISSIONS,
        query_os : {
            orderBy     : http_classSubChildName_os.udsqp_userId_uid,
            equalTo     : userId_uid,
        },
        cb_f :(uds_questPermissions_byId_o) => {


            let uds_questPermissions_ao = obj_toArray_fo(uds_questPermissions_byId_o)
            let uds_questPermissions_ac = uds_questPermissions_ao.map(uds_questPermissions_o => {return new FB_UserDataSub_QuestPermission(uds_questPermissions_o)})
            uds_questPermissions_ac = uds_questPermissions_ac.filter(uds_questPermissions_c => {return uds_questPermissions_c.udsqp_permission_n >= questMinPermission_n} )

            cb_f(uds_questPermissions_ac)
        }
    })

}

// serverPre_userDataSub_onlineUsers_cl_set_f
export const serverPre_userDataSub_onlineUsers_vl_set_f = (viewName_s, userId_uid, cb_f) => {
    http_database_onValueListener_open_f({
        viewName_s  : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_ONLINE_USERS.concat(userId_uid),
        cb_f :(ud_onlineUser_o) => {

            cb_f(ud_onlineUser_o ?
                new FB_UserDataSub_OnlineUser(ud_onlineUser_o) :
                new FB_UserDataSub_OnlineUser({ud_os_userId_uid : userId_uid}))
        }
    })
}
// serverPre_userDataSub_onlineRemove_cl_remove_f
export const serverPre_userDataSub_onlineUsers_vl_remove_f = (viewName_s, userId_uid) => {
    http_database_onValueListener_close_f({
        viewName_s  : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_ONLINE_USERS.concat(userId_uid),
    })
}

// serverPre_userDataSub_onlineUsers_update
export const serverPre_userDataSub_onlineUsers_update = (userId_uid) => {

    let ud_onlineUser_c = new FB_UserDataSub_OnlineUser({
        ud_os_userId_uid    : userId_uid,
        ud_os_lastMsgTime_t :  date_newDate_fd().getTime()
    })

    http_database_updateData_f({
        path_as : http_endPointPath_oa.PUDSC_ONLINE_USERS.concat(userId_uid),
        data_c  : ud_onlineUser_c,
        cb_f    : () => {},
    })
}

// serverPre_userDataSub_onlineUsers_update
export const serverPre_userDataSub_onlineUsers_getAll = (cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_ONLINE_USERS,
        query_os : {
            orderBy     : FB_UserDataSub_OnlineUser.ud_os_l_online_b,
            equalTo     : true,
        },
        cb_f    : (onlineUsers_byUid_o) => {
            let onlineUsers_byUid_c = {}
            for(let userId_uid in onlineUsers_byUid_o){
                onlineUsers_byUid_c[userId_uid] = new FB_UserDataSub_OnlineUser(onlineUsers_byUid_o[userId_uid])
            }
            cb_f(onlineUsers_byUid_c)
        },
    })
}



// Current User more info
export const serverPre_subUserData_moreInfo_get_f = ({userId_uid, cb_f}) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_MORE_INFO.concat(userId_uid),
        cacheFallback_b : true,
        cb_f    : (userData_moreInfo_o) => {

            if(userData_moreInfo_o == null){
                cb_f(new FB_UserDataSub_MoreInfo({
                    udsmi_userId_uid    : userId_uid,
                }))
            }else{
                cb_f(new FB_UserDataSub_MoreInfo(userData_moreInfo_o))
            }

        }
    })

}
export const serverPre_subUserData_moreInfo_update_f = (uds_moreInfo_c, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.PUDSC_MORE_INFO.concat(uds_moreInfo_c.udsmi_userId_uid),
        data_c  : uds_moreInfo_c,
        cb_f    : cb_f,
    })

}

// serverPre_subUserData_creditCards
export const serverPre_subUserData_creditCards_cl_set_f = ({viewName_s, userId_uid, cb_f}) =>{

    http_database_onChildListener_open_f({
        viewName_s  : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_CREDIT_CARD.concat(userId_uid),
        cb_f    : (uds_creditCard_o) => {
            cb_f(uds_creditCard_o ? new FB_UserDataSub_CreditCard(uds_creditCard_o) : null)
        }
    })

}
export const serverPre_subUserData_creditCards_cl_remove_f = ({viewName_s, userId_uid}) =>{

    http_database_onChildListener_close_f({
        viewName_s  : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_CREDIT_CARD.concat(userId_uid),
    })

}
export const serverPre_subUserData_creditCards_delete_f = ({userId_uid, creditCard_c, cb_f}) =>{

    http_database_setData_f({
        path_as : http_endPointPath_oa.PUDSC_CREDIT_CARD.concat(userId_uid, creditCard_c.udscc_m_id_s()),
        data_c  : null,
        cb_f    : cb_f
    })

}
export const serverPre_subUserData_creditCards_update_f = ({userId_uid, creditCard_c, cb_f}) =>{

    http_database_updateData_f({
        path_as : http_endPointPath_oa.PUDSC_CREDIT_CARD.concat(userId_uid, creditCard_c.udscc_m_id_s()),
        data_c  : creditCard_c,
        cb_f    : cb_f
    })
}

// Current User payment info
export const serverPre_subUserData_creatorPaymentInfo_get_f = ({userId_uid, cb_f}) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_CREATOR_PAYMENT_INFO.concat(userId_uid),
        cb_f    : (uds_creatorPaymentInfo_o) => {

            if(uds_creatorPaymentInfo_o == null){
                cb_f(new FB_UserDataSub_CreatorPaymentInfo({
                    udscpi_userId_uid    : userId_uid,
                }))
            }else{
                cb_f(new FB_UserDataSub_CreatorPaymentInfo(uds_creatorPaymentInfo_o))
            }

        }
    })

}
export const serverPre_subUserData_creatorPaymentInfo_update_f = (uds_creatorPaymentInfo_c, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.PUDSC_CREATOR_PAYMENT_INFO.concat(uds_creatorPaymentInfo_c.udscpi_userId_uid),
        data_c  : uds_creatorPaymentInfo_c,
        cb_f    : cb_f,
    })

}

// serverPre_subUserData_subscriptionPlanInfo_get_f
export const serverPre_subUserData_subscriptionPlanInfo_get_f = ({userId_uid, cb_f}) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PUDSC_SUBSCRIPTION_PLAN_INFO.concat(userId_uid),
        cb_f    : (uds_subscriptionPlanInfo_o) => {

            if(uds_subscriptionPlanInfo_o == null){
                uds_subscriptionPlanInfo_o = {
                    udsspi_userId_uid    : userId_uid,
                }
            }

            cb_f(new FB_UserDataSub_SubscriptionPlanInfo(uds_subscriptionPlanInfo_o))

        }
    })

}
export const serverPre_subUserData_subscriptionPlanInfo_update_f = (uds_subscriptionPlanInfo_o, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.PUDSC_SUBSCRIPTION_PLAN_INFO.concat(uds_subscriptionPlanInfo_o.udsspi_userId_uid),
        data_c  : uds_subscriptionPlanInfo_o,
        cb_f    : cb_f,
    })

}


// server_addTicketPointerToUser_f
export const server_addTicketPointerToUser_f = (userId_uid, questTicket_c, cb_f) =>{



    let data = new FB_UDS_QuestTicketPointer({
        qetp_ticketId_uid           : questTicket_c.qt_ticketId_uid,
        qetp_eventStartingDate_t    : questTicket_c.qt_eventStartingDate_t,
        qetp_orderBy_uid            : questTicket_c.qt_eventStartingDate_t + questTicket_c.qt_ticketId_uid
    })

    http_database_setData_f({
        path_as : http_endPointPath_oa.PUDSC_QUESTS_TICKETS.concat(userId_uid,questTicket_c.qt_ticketId_uid),
        data_c : data,
        cb_f : cb_f
    })

}

// serverPre_errors_set_f
export const serverPre_errors_set_f = ({error_c, cb_f}) =>{

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_ERRORS.concat(error_c.err_m_getId_s()),
        data_c : error_c,
        cb_f : cb_f
    })
}

// serverPre_errors_getAll_f
export const serverPre_errors_getAll_f = ({startDate_t, endDate_n, cb_f}) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_ERRORS,
        query_os : {
            orderBy     : FB_Error.err_name_time_t(),
            startAt     : startDate_t,
            endAt       : endDate_n,
        },
        cb_f : (errors_ao) => {
            let errors_ac = obj_map_fo(errors_ao, (error_o) => new FB_Error(error_o))

            cb_f(obj_toArray_fo(errors_ac))
        }
    })
}

// server_getUserQuestReview_fp
export const server_getUserQuestReview_fp = (questType_e, questId_uid, userId_uid, cb_f) => {


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PRE_QUESTS_REVIEWS.concat(questType_e, questId_uid,  userId_uid),

        cb_f    : (questReview_o) => {
            cb_f(questReview_o != null ? new FB_QuestReview(questReview_o) : null)
        }
    })



    // let ref = getRef_questReviews_f(questType_e, questId_uid).child(eventId_uid + userId_uid)
    // return serverStorage2_getDataOnce_fp({
    //     key_s : "server_getUserQuestReview_f" + questType_e + questId_uid + eventId_uid + userId_uid,
    //     getServerData_pf(){
    //         return realTimeDB_setOnceListener_fp(ref)
    //     }
    // }).then(questReview_o => {
    //     if(questReview_o){
    //         return null
    //     }else{
    //         return new FB_QuestReview(questReview_o)
    //     }
    // })



}

// server_submitQuestTqReview_f
export const server_submitQuestTqReview_f = (questReview_c, cb_f) =>{

    // 1) add new review
    http_database_setData_f({
        path_as : http_endPointPath_oa.PRE_QUESTS_REVIEWS.concat(questReview_c.qr_questType_e,questReview_c.qr_questId_uid, questReview_c.qr_reviewerId_uid),
        data_c : questReview_c,
        cb_f : () => {

            // 2) update questExploreInfo participated
            http_database_transaction_f({
                path_as : http_endPointPath_oa.DATABASE_MAIN_QUESTS_EXPlORE_INFO.concat(questReview_c.qr_questType_e, questReview_c.qr_questId_uid),

                updateData_fo : (questExploreInfo_o) =>{

                    // first review
                    if(questExploreInfo_o.qexi_reviewedNum_n == null || questExploreInfo_o.qexi_reviewedNum_n === 0){
                        questExploreInfo_o.qexi_reviewedNum_n           = 1

                        questExploreInfo_o.qexi_overallRatingAvg_n      = questReview_c.qr_overallRating_n
                        questExploreInfo_o.qexi_difficultyAvg_n         = questReview_c.qr_difficulty_n


                    // not first review
                    }else{

                        questExploreInfo_o.qexi_overallRatingAvg_n      = helper_calculateSum_n(questExploreInfo_o.qexi_reviewedNum_n, questExploreInfo_o.qexi_overallRatingAvg_n, questReview_c.qr_overallRating_n)
                        questExploreInfo_o.qexi_difficultyAvg_n         = helper_calculateSum_n(questExploreInfo_o.qexi_reviewedNum_n, questExploreInfo_o.qexi_difficultyAvg_n, questReview_c.qr_difficulty_n)
                        questExploreInfo_o.qexi_reviewedNum_n++

                    }

                    return questExploreInfo_o
                },
                cb_f : cb_f,
            })
        }
    })


}

// more info
export const serverPre_moreInfo_update_f = ({moreInfo_c, cb_f}) => {

    moreInfo_c.mi_lastEdit_t = date_nowTime_t()

    http_database_updateData_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_MORE_INFO.concat(moreInfo_c.mi_id_uid),
        data_c  : moreInfo_c,
        cb_f    : cb_f
    })
}
export const serverPre_moreInfo_get_one_f = ({mi_id_uid, cb_f}) => {
    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_MORE_INFO.concat(mi_id_uid),
        cb_f : (moreInfo_o) => {

            cb_f(moreInfo_o ? new FB_MoreInfo(moreInfo_o): null)
        }
    })
}


// server_userLoveQuest_f
export const server_userLoveQuest_f = (userId_uid, questExplore_c, lovedQuest_b) => {


    let data_c = lovedQuest_b ?
        null :
        new FB_QuestPointer({
            qp_questId_uid : questExplore_c.qex_questId_uid,
            qp_questType_e : questExplore_c.qex_questType_e,
        })

    // update server
    http_database_setData_f({
        path_as : http_endPointPath_oa.PUDSC_LOVED_QUESTS.concat(userId_uid, questExplore_c.qex_questId_uid),
        data_c : data_c,
    })

}


// ============== others ============================

// server_sendMail_f
export const server_sendMail_fp = (sendEmail_c) => {

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_sendEmail,
        data_c: sendEmail_c,
    })

}

// serverPre_chargeTicket_f
export const serverPre_chargeTicket_f = ({ticketId_uid}) => {

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_chargeTicket,
        data_c: {ticketId_uid : ticketId_uid},
    })

}

// server_questReviews_get_last3_f
export const server_questReviews_get_last3_f = (questType_e, questId_uid, lastTimestamp_t, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PRE_QUESTS_REVIEWS.concat(questType_e, questId_uid),
        query_os : {
            orderBy     : http_classSubChildName_os.qr_timestamp_t,
            limitToLast : 5,
            endAt       : lastTimestamp_t ? lastTimestamp_t-1 : null,
        },
        cb_f : (questReview_byUserId_o) => {

            let lastTimestamp_t = null

            let questReview_byUserId_c = obj_map_fo(questReview_byUserId_o, (questReview_o) => {
                let questReview_c = new FB_QuestReview(questReview_o)
                if(lastTimestamp_t == null || lastTimestamp_t > questReview_c.qr_timestamp_t){
                    lastTimestamp_t = questReview_c.qr_timestamp_t
                }

                return new FB_QuestReview(questReview_o)
            })


            // obj to arr
            let questReview_ac = Object.values(questReview_byUserId_c)
            let sortQuestReview_ac = questReview_ac.sort((questReview1_c, questReview2_c) => {
                return questReview2_c.qr_timestamp_t - questReview1_c.qr_timestamp_t
            })

            cb_f(sortQuestReview_ac, lastTimestamp_t)
        }
    })
}

// server_lastQuestReviewsPointers_get_last10_f
export const server_lastQuestReviewsPointers_get_last12_f = (cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.PRE_LAST_QUEST_REVIEWS_POINTERS,
        query_os : {
            orderBy     : FB_LastQuestReviewPointer.lqrp_l_timestamp_t,
            limitToLast : 12,
        },
        cb_f : (lastQuestReviewsPointers_byTimestemp_o) => {

            let lastQuestReviewsPointers_byTimestemp_c = obj_map_fo(lastQuestReviewsPointers_byTimestemp_o, (lastQuestReviewsPointers_o) => {
                return  new FB_LastQuestReviewPointer(lastQuestReviewsPointers_o)
            })

            // obj to arr
            let lastQuestReviewsPointers_ac = Object.values(lastQuestReviewsPointers_byTimestemp_c)

            cb_f(lastQuestReviewsPointers_ac)
        }
    })
}


// server_getQuestExploreInfo_f
export const server_getQuestExploreInfo_f = (questExplore_c, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_QUESTS_EXPlORE_INFO.concat(questExplore_c.qex_questType_e, questExplore_c.qex_questId_uid),
        cb_f    : (data_o) => {

            cb_f(data_o != null
                ? new FB_QuestExplore_Info(data_o)
                : new FB_QuestExplore_Info({
                    qexi_questId_uid: questExplore_c.qex_questId_uid,
                    qexi_questType_e: questExplore_c.qex_questType_e,
                }))
        }
    })

    // let ref = getRef_questExploreInfo(questExplore_c.qex_questType_e, questExplore_c.qex_questId_uid);
    //
    // return serverStorage2_getDataOnce_fp({
    //     key_s : "server_getQuestExploreInfo_f_" + questExplore_c.qex_questType_e + questExplore_c.qex_questId_uid,
    //     getServerData_pf(){
    //         return realTimeDB_setOnceListener_fp(ref)
    //     }
    // }).then(questExploreInfo_o => {
    //     if(questExploreInfo_o == null){
    //         questExploreInfo_o = new FB_QuestExploreInfo({
    //             qexi_questId_uid: questExplore_c.qex_questId_uid,
    //             qexi_questType_e: questExplore_c.qex_questType_e,
    //         })
    //     }
    //     return new FB_QuestExploreInfo(questExploreInfo_o)
    // })


}

// server_tqInfo_getOnce_fp
export const server_tqInfo_getOnce_fp =(cb_f) =>{


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_TQ_INFO,
        cb_f    : (data_o) => {
            cb_f(new FB_TqInfo(data_o))
        }
    })



}

// server_questBackupsInfo_getOnce_fp
export const server_questBackupsInfo_getOnce_fp =(questId_uid, questType_e, cb_f) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_QUESTS_BACKUP_INFO.concat(questId_uid, questType_e),
        cb_f    : (questBackupsInfo_byBackupIdId_o) => {

            if(questBackupsInfo_byBackupIdId_o == null){
                questBackupsInfo_byBackupIdId_o = []
            }

            cb_f(Object.values(questBackupsInfo_byBackupIdId_o).map(questBackupInfo_o => {return new FB_QuestBackupInfo(questBackupInfo_o)}))

        }
    })

    // let ref = getRef_questVersionsInfo_fo(questId_uid, questType_e)
    //
    // return serverStorage2_getDataOnce_fp({
    //     key_s: "server_questBackupsInfo_getOnce_fp" +  questId_uid + questType_e,
    //     getServerData_pf(){
    //         return realTimeDB_setOnceListener_fp(ref)
    //     }
    // }).then( (questBackupsInfo_byBackupIdId_o) => {
    //
    //     if(questBackupsInfo_byBackupIdId_o == null){
    //         return []
    //     }
    //
    //     return Object.values(questBackupsInfo_byBackupIdId_o).map(questBackupInfo_o => {return new FB_QuestBackupInfo(questBackupInfo_o)})
    // })


}

// server_getAllForumsData_once_f
export const server_blogArticles_once_fp = (getOnlyActiveQuest_b, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_FORUMS_DATA,
        query_os : getOnlyActiveQuest_b ? {
            orderBy     : http_classSubChildName_os.ba_active_b,
            equalTo     : true,
        } : {},
        cb_f    : (articlesData_byArticleId_o) => {


            if(articlesData_byArticleId_o == null){
                articlesData_byArticleId_o = {}
            }

            let articlesData_byArticleId_c = obj_map_fo(articlesData_byArticleId_o, (forumData_o) => {
                return new FB_BlogArticle(forumData_o)
            })

            cb_f(articlesData_byArticleId_c)
        }
    })

}

// server_getAllForumsData_once_f
export const server_getArticle_once_fp = (blogArticleId_uid, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_FORUMS_DATA.concat(blogArticleId_uid),
        cb_f    : (blogArticle_o) => {

            cb_f(blogArticle_o ? new FB_BlogArticle(blogArticle_o): null)

        }
    })

}

// server_addNewBlogArticle_f
export const server_blogArticle_getNewTicket_f = (cb_f) => {

    http_database_getNewKey_f({
        path_as: http_endPointPath_oa.DATABASE_MAIN_FORUMS_DATA,
        cb_f : (newBlogArticleId_uid)=>{
            let blogArticle_c = new FB_BlogArticle({ba_articleId_uid: newBlogArticleId_uid})

            cb_f(blogArticle_c)
        }})
}

// server_forumData_set_f
export const server_forumData_set_f = (forumData_c, cb_f) => {

    forumData_c.fd_lastEditTime_t = date_newDate_fd().getTime()

    http_database_updateData_f({
            path_as : http_endPointPath_oa.DATABASE_MAIN_FORUMS_DATA.concat(forumData_c.ba_articleId_uid),
            data_c : forumData_c,
            cb_f : cb_f,
        })

}

// serverPre_reportReview_f
export const serverPre_reportReview_set_f = ({questType_e, questId_uid, reviewerUserId_uid, reportUserId_uid, reportText_s, cb_f}) => {

    http_database_getNewKey_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_REPORTS_REVIEWS,
        cb_f : (newKey_uid) =>{

            let reportReview_c = new FB_Report_Review({
                rr_reportReview_uid     : newKey_uid,
                rr_questType_e          : questType_e,
                rr_questId_uid          : questId_uid,
                rr_reviewerUserId_uid   : reviewerUserId_uid,
                rr_reportUserId_uid     : reportUserId_uid,
                rr_reportTime_t         : date_newDate_fd().getTime(),
                rr_text_s               : reportText_s,
                rr_status_e             : enum_reportReviewStatus_e.open
            })

            http_database_setData_f({
                path_as : http_endPointPath_oa.DATABASE_PRE_REPORTS_REVIEWS.concat(newKey_uid),
                data_c  : reportReview_c,
                cb_f    : cb_f
            })
        }
    })
}
export const serverPre_reportReview_update_f = (reportReview_c, cb_f) => {

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_REPORTS_REVIEWS.concat(reportReview_c.rr_reportReview_uid),
        data_c  : reportReview_c,
        cb_f    : cb_f
    })
}
export const serverPre_reportReview_getOnce_f = ({reportReview_e, cb_f}) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_REPORTS_REVIEWS,
        query_os : {
            orderBy     : http_classSubChildName_os.rr_status_e,
            equalTo     : reportReview_e,
        },
        cb_f    : (reportReview_o) => {

            let reportsReviews_byReportId_c = obj_map_fo(reportReview_o, (reportReview_o) => {return new FB_Report_Review(reportReview_o)})
            cb_f(reportsReviews_byReportId_c)
        }
    })
}


// =========== 2) quests files =============

// serverPre_questFile_add_f
export const serverPre_userFiles_add_f = ({userId_uid, file_c, folderPath_ac, cb_f}) => {

    let uploadToRealTimeDb_f = () => {

        let path_as = http_endPointPath_oa.DATABASE_MAIN_CREATORS_FILES.concat(userId_uid)

        folderPath_ac.forEach(folderFile_c => {
            path_as = path_as.concat(folderFile_c.fi_uploadDate_t, FB_File.fi_l_folderFiles_byUploadDate_c)
        })
        path_as = path_as.concat(file_c.fi_uploadDate_t)

        http_database_setData_f({
            path_as : path_as,
            data_c  : file_c,
            cb_f    : cb_f
        })
    }

    switch(file_c.fi_type_e){
        case enum_fileType.folder:
            uploadToRealTimeDb_f()
            break;
        default:
            http_storage_uploadFile_f({
                file_c : file_c,
                path_as : http_endPointPath_oa.STORAGE_USERS_DRIVE.concat(userId_uid),
                cb_f : () =>{
                    uploadToRealTimeDb_f()
                }
            })
    }
}

// serverPre_creatorFile_updateTree_f
export const serverPre_creatorFiles_update_f = ({userId_uid, userFiles_byUploadedDate_c, cb_f}) => {

    let path_as = http_endPointPath_oa.DATABASE_MAIN_CREATORS_FILES.concat(userId_uid)

    http_database_setData_f({
        path_as : path_as,
        data_c  : userFiles_byUploadedDate_c,
        cb_f    : cb_f
        })


}

// serverPre_questFile_delete_f
export const serverPre_creatorFile_delete_f = ({userId_uid, file_c, folderPath_ac, cb_f}) => {


    http_storage_deleteFile_fp({
        file_c : file_c,
        path_as: http_endPointPath_oa.STORAGE_USERS_DRIVE.concat(userId_uid)
    }).then(fbAns_o => {

        let path_as = http_endPointPath_oa.DATABASE_MAIN_CREATORS_FILES.concat(userId_uid)
        folderPath_ac.forEach(folderFile_c => {
            path_as = path_as.concat(folderFile_c.fi_uploadDate_t, FB_File.fi_l_folderFiles_byUploadDate_c)
        })
        path_as = path_as.concat(file_c.fi_uploadDate_t)

        http_database_setData_f({
            path_as : path_as,
            data_c  : null,
            cb_f    : cb_f
        })
    })

    // storage_deleteFile_fp(file_c, ref_storage, () => {
    //
    //     let path_as = http_endPointPath_oa.DATABASE_MAIN_CREATORS_FILES.concat(userId_uid)
    //     folderPath_ac.forEach(folderFile_c => {
    //         path_as = path_as.concat(folderFile_c.fi_uploadDate_t, FB_File.fi_l_folderFiles_byUploadDate_c)
    //     })
    //     path_as = path_as.concat(file_c.fi_uploadDate_t)
    //
    //     http_database_setData_f({
    //         path_as : path_as,
    //         data_c  : null,
    //         cb_f    : cb_f
    //     })
    // })


}

// serverPre_userFiles_get_f
export const serverPre_userFiles_get_f = ({userId_uid, cb_f}) => {
    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_CREATORS_FILES.concat(userId_uid),
        cb_f    :  (files_byUploadDate_o) => {


            if(files_byUploadDate_o == null){
                cb_f({})
            }else{

                let files_uploadData_c = {}
                let firstTime =true

                let recursiveNewFileClass_f = (files_byUploadDate_o, level) => {
                    let files_uploadData_c = {}


                    for(let file_uploadData_t in files_byUploadDate_o){

                        try{
                            let file_c = new FB_File(files_byUploadDate_o[file_uploadData_t])
                            files_uploadData_c[file_c.fi_uploadDate_t] = file_c

                            if(file_c.fi_m_isFolder_fb()){
                                console.log(file_uploadData_t, level)
                                file_c.fi_folderFiles_byUploadDate_c = recursiveNewFileClass_f(file_c.fi_folderFiles_byUploadDate_c, level + 1)
                            }
                        }catch{
                            if(firstTime){
                                firstTime = false
                                console.log('firstTime', file_uploadData_t, level)
                            }
                        }
                    
                   

                    
                
                    }
                    return files_uploadData_c
                }

                files_uploadData_c = recursiveNewFileClass_f(files_byUploadDate_o, 0)
                cb_f(files_uploadData_c)
            }
        }
    })
}

// =========== 2) quests events =============

// server_questEvents_cl
export const server_questEvents_cl_set_f    = (viewName_s, questType, questId, startingDate_t, endingDate_t, cb_f) => {


    http_database_onChildListener_open_f({
        viewName_s  : viewName_s,
        path_as     : http_endPointPath_oa.QUESTS_EVENTS.concat(questType, questId),
        query_os : {
                    orderBy : fbRef_subRef.qev_startingDate_t,
                    startAt : startingDate_t-10,
                    endAt   : endingDate_t,
                },
        cb_f : (questEvent_o) => {
            cb_f(questEvent_o == null ? null : new FB_QuestEvent(questEvent_o))
        }
    })


    // let ref = getRef_questEventOrderByStartingDate(questType, questId)
    //
    // if(startingDate_t != null){
    //     ref = ref.startAt(startingDate_t)
    // }
    // if(endingDate_t != null){
    //     ref = ref.endAt(endingDate_t)
    // }
    //
    // realTimeDB_setOnChildListener(ref,
    //     (value)=>{
    //         console.log(value)
    // }, ()=>{
    //
    // })

}
export const server_questEvents_cl_remove_f = (viewName_s, questType, questId, startingDate_t, endingDate_t) =>{

    http_database_onChildListener_close_f({
        viewName_s  : viewName_s,
        query_os : {
            orderBy : fbRef_subRef.qev_startingDate_t,
            startAt : startingDate_t,
            endAt   : endingDate_t,
        },
        path_as     : http_endPointPath_oa.QUESTS_EVENTS.concat(questType, questId)
    })


    // let ref = REF_REALTIME_PRE_QUESTS_EVENTS.child(questType).child(questId)
    // serverStorage_removeListener_f(
    //     enum_endPointsNames.questEvents,
    //     viewName_s,
    //     getRefKey_fs(ref),
    //     () => {
    //         removeRefListener(ref)
    //     }
    // )
}

// server_questEvents_cl_once_f
export const server_questEvents_once_f = (questType, questId, startingDate_t, endingDate_t, cb_f) => {

    http_database_getOnce_f({
        path_as: http_endPointPath_oa.QUESTS_EVENTS.concat(questType, questId),
        query_os: {
            orderBy : fbRef_subRef.qev_startingDate_t,
            startAt : startingDate_t,
            endAt   : endingDate_t,
        },
        cb_f: (questEvents_byEventId_o) => {

            if (questEvents_byEventId_o == null) {

                cb_f({})

            } else {

                let questEvents_byEventId_c = obj_map_fo(questEvents_byEventId_o, (questEvent_o) => {
                    return new FB_QuestEvent(questEvent_o)
                });

                cb_f(questEvents_byEventId_c)
            }
        }
    });

}

// server_getQuestEvent
export const server_questEvent_once_f =  (questType_uid, questId_uid, eventId_uid, cacheFallback_b,  cb_f) => {

    // TQ_HANDEL_NEW_CHANGES : change questEvent primary key
    if(questType_uid == null || questId_uid == null || eventId_uid == null){
        cb_f(null)
        return
    }

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questType_uid, questId_uid, eventId_uid),
        cacheFallback_b,
        cb_f    : (data_o) => {
            cb_f(data_o != null ? new FB_QuestEvent(data_o) : null)
        }
    })

}

// server_getQuestEvent_vl
export const server_questEvent_vl_set_f = (viewName_s, questType, questId, eventId, cbAdded_f)=> {


    // TODO: TQ_HANDEL_NEW_CHANGES : change questEvent primary key
    if(questType == null || questId == null || eventId == null){
        return
    }

    http_database_onValueListener_open_f({
        viewName_s  : viewName_s,
        path_as     : http_endPointPath_oa.QUESTS_EVENTS.concat(questType, questId, eventId),
        cb_f : (questEvent_o) => {
            cbAdded_f(questEvent_o != null ? new FB_QuestEvent(questEvent_o) : null)
        }
    })



}
export const server_questEvent_vl_remove_f = (viewName_s, questType, questId, eventId) => {
    // const ref = getRef_questEvent(questType, questId, eventId)
    //
    // serverStorage_removeListener_f(
    //     enum_endPointsNames.getQuestEvent,
    //     viewName_s,
    //     getRefKey_fs(ref),
    //     () => {
    //         removeRefListener(ref)
    //     }
    // )

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questType, questId, eventId)
    })

}

// server_setQuestEventStartingDate
export const server_questEvent_setStartingDate = (questEvent, cb_f) => {

    // const ref = getRef_questEvent(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid).child(enum_fbPath.questsEvent_startingDate)
    // realTimeDB_setData(ref, questEvent.qev_startingDate_t, cb)

    http_database_setData_f({
        path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid, enum_fbPath.questsEvent_startingDate),
        data_c  : questEvent.qev_startingDate_t,
        cb_f    : cb_f
    })



}

// server_questEvent_create_f
export const server_questEvent_create_f = (questExplore_c, name_byLangCode_s, imgFile_blc_c, stackClockType_e, eventDateTime_t) => {

    http_database_getNewKey_f({
        path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questExplore_c.qex_questType_e, questExplore_c.qex_questId_uid),
        cb_f    : (newKey_s) => {

            let newQuestEvent_c = new FB_QuestEvent({
                qev_supportedLangCodes_ae       : questExplore_c.qex_langArr_ae,
                qev_defaultLang_e               : questExplore_c.qex_mainLang_e,
                qev_name_byLangCode_s           : name_byLangCode_s,
                qev_imgFile_blc_c               : imgFile_blc_c,

                qev_startingDate_t              : eventDateTime_t,

                qev_durationInMinutes_n         : questExplore_c.qex_durationInMinutes_n,
                qev_ticketsStatus_byTicketId_b  : {},

                // id
                qev_questId_uid         : questExplore_c.qex_questId_uid,
                qev_questType_e         : questExplore_c.qex_questType_e,
                qev_eventId_uid         : newKey_s,
                qev_creatorId_uid       : questExplore_c.qex_creatorId_uid,
                qev_utcOffSetHours_n    : questExplore_c.qex_utcOffSetHours_n,

                qev_emailBoughtTicket_blc_s : questExplore_c.qex_emailBoughtTicket_blc_html,
                qev_emailFinishQuest_blc_s  : questExplore_c.qex_emailFinishQuest_blc_html,

                qev_startClockType_e  : stackClockType_e,


            })

            http_database_setData_f({
                path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questExplore_c.qex_questType_e, questExplore_c.qex_questId_uid, newKey_s),
                data_c : newQuestEvent_c,
                cb_f : ()=> {}
            })
        }
    });

}

// server_questEvent_update_f
export const server_questEvent_update_f = (questEvent_c, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid),
        data_c : questEvent_c,
        cb_f : cb_f,
    })
}

// server_questEvent_delete_f
export const server_questEvent_delete_f = (questEvent_c, cb_f) => {

    // const ref_o = REF_REALTIME_PRE_QUESTS_EVENTS.child(questEvent_c.qev_questType_e).child(questEvent_c.qev_questId_uid).child(questEvent_c.qev_eventId_uid)
    // realTimeDB_setData(ref_o, null, cb_f)


    http_database_setData_f({
        path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid),
        data_c  : null,
        cb_f    : cb_f
    })


}

// =========== 3) tickets =============

// server_requestedTickets_once_f
export const server_tickets_startDate_once_f = (startDate_t, endData_t, cb_f) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.QUESTS_TICKETS,
        query_os : {
            orderBy     : http_classSubChildName_os.qt_saleDate_t,
            startAt     : startDate_t,
            endAt     : endData_t,
        },
        cb_f    : (questsTickets_byTicketId_o) => {

            let questsTickets_byTicketId_c = obj_map_fo(questsTickets_byTicketId_o, (questTicket_o) => {return new FB_QuestTicket(questTicket_o)})
            cb_f(questsTickets_byTicketId_c)
        }
    })
};

// server_requestedTickets_once_f
export const server_requestedTickets_once_f = (cb_f) =>{

    return http_database_getOnce_f({
        path_as : http_endPointPath_oa.QUESTS_TICKETS,
        query_os : {
            orderBy     : http_classSubChildName_os.qt_status_e,
            equalTo     : enum_questTicketStatus.creatorRequest,
        },
        cb_f    : (questsTickets_byTicketId_o) => {

            let questsTickets_byTicketId_c = obj_map_fo(questsTickets_byTicketId_o, (questTicket_o) => {return new FB_QuestTicket(questTicket_o)})
            cb_f(questsTickets_byTicketId_c)
        }
    })
};

// server_approveTicket
export const serverPre_updateTicket_f = (questTicket_c, spotsGap_n) =>{

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_questTicket_edit,
        data_c:         {
            questTicket_c : questTicket_c,
            spotsGap_n : spotsGap_n,
        }
    })

};

// server_creatorRequestTicket_f
export const server_creatorRequestTicket_f = (questTicket_c) => {

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_questTicket_new,
        data_c: {questTicket_c : questTicket_c}
    })

}

// server_cancelTicket
export const server_cancelTicket_f = (questEvent, questTicket_c, cb_f) =>{

    // let ref_questTicket_o = REF_REALTIME_PRE_QUESTS_TICKETS.child(questTicket_c.qt_ticketId_uid)

    questTicket_c.qt_status_e = enum_questTicketStatus.canceled;
    questTicket_c.qt_history_ac.push(new FB_QuestTicket_History({
        qth_timestamp_t     : date_newDate_fd().getTime(),
        qth_actions_e       : enum_questTicketActions.cancel,
    }))

    // 1) update ticket
    // realTimeDB_updateData(ref_questTicket_o, questTicket_c, () =>{
    //
    //     http_database_transaction_f({
    //         path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid),
    //
    //         updateData_fo : (questEvent_o) =>{
    //
    //
    //             // change questEvent ticket status
    //             if(questEvent_o.qev_ticketsStatus_byTicketId_b != null){
    //                 questEvent_o.qev_ticketsStatus_byTicketId_b[questTicket_c.qt_ticketId_uid] = false
    //             }
    //
    //             // set quest players Num
    //             if(questEvent_o.qev_playersNum_n != null){
    //                 questEvent_o.qev_playersNum_n -= questTicket_c.qt_spots_n
    //
    //                 if(questEvent_o.qev_playersNum_n < 0){
    //                     questEvent_o.qev_playersNum_n = 0
    //                 }
    //             }
    //
    //
    //             return questEvent_o
    //         },
    //         cb_f : cb_f,
    //     })
    //
    // });

    http_database_updateData_f({
        path_as : http_endPointPath_oa.QUESTS_TICKETS.concat(questTicket_c.qt_ticketId_uid),
        data_c : questTicket_c,
        cb_f :  () =>{

            http_database_transaction_f({
                path_as : http_endPointPath_oa.QUESTS_EVENTS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid),

                updateData_fo : (questEvent_o) =>{


                    // change questEvent ticket status
                    if(questEvent_o.qev_ticketsStatus_byTicketId_b != null){
                        questEvent_o.qev_ticketsStatus_byTicketId_b[questTicket_c.qt_ticketId_uid] = false
                    }

                    // set quest players Num
                    if(questEvent_o.qev_playersNum_n != null){
                        questEvent_o.qev_playersNum_n -= questTicket_c.qt_spots_n

                        if(questEvent_o.qev_playersNum_n < 0){
                            questEvent_o.qev_playersNum_n = 0
                        }
                    }


                    return questEvent_o
                },
                cb_f : cb_f,
            })

        }
    })

};

// server_getQuestTicket
export const server_getQuestTicket_once_f =  (ticketId, cacheFallback_b, cb_f) => {

    if(ticketId == null){
        cb_f(null)
        return
    }

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.QUESTS_TICKETS.concat(ticketId),
        cacheFallback_b,
        cb_f    : (questTicket_o) => {

            cb_f(questTicket_o == null? null : new FB_QuestTicket(questTicket_o))
        }
    })

    // const ref = REF_REALTIME_PRE_QUESTS_TICKETS.child(ticketId)
    //
    // return serverStorage2_getDataOnce_fp({
    //     key_s : "server_getQuestTicket_once_" + ticketId,
    //     getServerData_pf(){
    //         return realTimeDB_setOnceListener_fp(ref)
    //     },
    //     getOnlyFromServer_b : true
    // }).then(questTicket_c => {
    //     cb_f(new FB_QuestTicket(questTicket_c))
    // })
}

export const server_questTicket_vl_set =  (viewName_s, ticketId_uid, cacheFallback_b, cb_f) => {

    http_database_onValueListener_open_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.QUESTS_TICKETS.concat(ticketId_uid),
        cacheFallback_b,
        cb_f : (questTicket_o) => {
            cb_f(questTicket_o != null ? new FB_QuestTicket(questTicket_o) : null)
        }
    })

}
export const server_questTicket_vl_remove =  (viewName_s, ticketId_uid) => {

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.QUESTS_TICKETS.concat(ticketId_uid),
    })
}

// server_creatorMonthlyTickets_vl_set
export const server_creatorMonthlyTickets_vl_set =  ({viewName_s, userId_uid, cb_f}) => {

    let date_yyyy_mm_s = format_date_YYYY_MM_fs(date_nowTime_t(), 0)

    http_database_onValueListener_open_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_CREATOR_MONTHLY_TICKETS.concat(userId_uid, date_yyyy_mm_s),
        cb_f : (creatorMonthlyTickets_o) => {

            cb_f(creatorMonthlyTickets_o ?
                new FB_UDS_CreatorMonthlyTickets(creatorMonthlyTickets_o):
                new FB_UDS_CreatorMonthlyTickets({
                    udscmt_userId_uid: userId_uid,
                    udscmt_yyyy_mm_s: date_yyyy_mm_s,
                    udscmt_totalSpots_n: 0,
                    udscmt_receipt_s: null
                }))

        }
    })

}
export const server_creatorMonthlyTickets_vl_remove =  ({viewName_s, userId_uid}) => {
    let date_yyyy_mm_s = format_date_YYYY_MM_fs(date_nowTime_t(), 0)

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.PUDSC_CREATOR_MONTHLY_TICKETS.concat(userId_uid, date_yyyy_mm_s)
    })
}

// server_playerUseTicket_f
export const server_playerUseTicket_f = (questTicket_c, playerId_uid, cb_f) => {


    // 1) add player to quest ticket
    http_database_transaction_f({
        path_as : http_endPointPath_oa.QUESTS_TICKETS.concat(questTicket_c.qt_ticketId_uid),

        updateData_fo : (questTicket_trans_o) =>{

            // TODO: refactor the next lines(double check in player/tickets)
            if(obj_size_fn(questTicket_trans_o.qt_playersJoinDate_byUserId_t) >= questTicket_trans_o.qt_spots_n ){
                return
            }

            if(questTicket_trans_o.qt_playersJoinDate_byUserId_t == null){ questTicket_trans_o.qt_playersJoinDate_byUserId_t = {}}
            questTicket_trans_o.qt_playersJoinDate_byUserId_t[playerId_uid] = date_newDate_fd().getTime()

            return questTicket_trans_o
        },
        cb_f : () => {

            // 2) update questExploreInfo participated
            http_database_transaction_f({
                path_as : http_endPointPath_oa.DATABASE_MAIN_QUESTS_EXPlORE_INFO.concat(questTicket_c.qt_questType_e, questTicket_c.qt_questId_uid),

                updateData_fo : (questExploreInfo_o) =>{


                    if(questExploreInfo_o.qexi_questId_uid == null || questExploreInfo_o.qexi_questType_e == null){
                        questExploreInfo_o.qexi_questId_uid = questTicket_c.qt_questId_uid
                        questExploreInfo_o.qexi_questType_e = questTicket_c.qt_questType_e
                    }

                    if(questExploreInfo_o.qexi_participated_n == null){questExploreInfo_o.qexi_participated_n = 0}
                    questExploreInfo_o.qexi_participated_n++

                    return questExploreInfo_o
                },
                cb_f : cb_f,
            })
        },
    })



    // 1) add player to quest ticket
    // realTimeDB_updateData_transaction(
    //     getRef_questTicket_fo(questTicket_c.qt_ticketId_uid),
    //     (questTicket_trans_c) => {
    //
    //
    //         // TODO: refactor the next lines(double check in player/tickets)
    //         if(obj_size_fn(questTicket_trans_c.qt_playersJoinDate_byUserId_t) >= questTicket_trans_c.qt_spots_n ){
    //             return
    //         }
    //
    //         if(questTicket_trans_c.qt_playersJoinDate_byUserId_t == null){ questTicket_trans_c.qt_playersJoinDate_byUserId_t = {}}
    //         questTicket_trans_c.qt_playersJoinDate_byUserId_t[playerId_uid] = date_getNowTime_ft()
    //
    //     },
    //     () => {
    //
    //         // 2) update questExploreInfo participated
    //         realTimeDB_updateData_transaction(
    //             getRef_questExploreInfo(questTicket_c.qt_questType_e, questTicket_c.qt_questId_uid),
    //             (questExploreInfo_c) => {
    //
    //                 if(questExploreInfo_c.qexi_questId_uid == null || questExploreInfo_c.qexi_questType_e == null){
    //                     questExploreInfo_c.qexi_questId_uid = questTicket_c.qt_questId_uid
    //                     questExploreInfo_c.qexi_questType_e = questTicket_c.qt_questType_e
    //                 }
    //
    //                 if(questExploreInfo_c.qexi_participated_n == null){questExploreInfo_c.qexi_participated_n = 0}
    //                 questExploreInfo_c.qexi_participated_n++
    //
    //             },
    //             cb_f)
    //     }
    // )
}

// server_getPaymentLandingPage_j5_f
export const server_getPaymentLandingPage_j5_f = ({questName_s, questId_uid, cost_c, spots_n, startingDate_t, langCode_e, customerName_s, phoneNumber_s,
                                                 currentUserData_c,  eventId_uid=null, couponId_uid, agentId_uid, discountPercentage_n, cb_f, errorCb_f}) => {

    http_database_getNewKey_f({
        path_as : http_endPointPath_oa.QUESTS_TICKETS,
        cb_f : (newTicketId_uid) =>{

            http_functions_fp({
                path_as: http_endPointPath_oa.FUNCTIONS_endPoint_icredit_GetUrl,
                data_c: {
                    GroupPrivateToken       : null,
                    Items:[{
                        "CatalogNumber"     : questId_uid,
                        "Quantity"          : 1,
                        "UnitPrice"         : cost_c.c_value_n,
                        "Description"       : `Bought ticket with ${spots_n} slots to "${questName_s}" quest`
                    }],
                    Currency            : cost_c.c_currency_e,
                    // RedirectURL         : `${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.standAlong_paymentSuccess)}?${enum_urlParams.ticketId}=${newTicketId_uid}`,
                    // FailRedirectURL     : `${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.standAlong_paymentFailed)}?${enum_urlParams.ticketId}=${newTicketId_uid}`,
                    RedirectURL         : `${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.standAlong_iframeSuccessMsg)}?msg=${enum_iframeMsg.success_s}`,
                    FailRedirectURL     : `${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.standAlong_iframeFailedMsg)}?msg=${enum_iframeMsg.failed_s}`,
                    IPNURL              : gv_fun_env.currentProject_e !== enum_projectEnv_s.tq_pro ? gv_urls.icredit_IPN_dev : gv_urls.icredit_IPN,
                    IPNFailureURL       : gv_fun_env.currentProject_e !== enum_projectEnv_s.tq_pro ? gv_urls.icredit_IPNFailure_dev : gv_urls.icredit_IPNFailure,

                    ExemptVAT           : false,
                    SaleType            : enum_saleType_n.waiting, // J5
                    CreateToken         : false,
                    MaxPayments         : 1,
                    HideItemList        : true,
                    DocumentLanguage    : langCode_e,

                    CustomerFirstName   : customerName_s,
                    CustomerLastName    : customerName_s,
                    EmailAddress        : currentUserData_c.ud_email_s,
                    PhoneNumber         : phoneNumber_s === '' ? null : phoneNumber_s,

                    Custom1             : questId_uid,
                    Custom2             : agentId_uid,
                    Custom3             : JSON.stringify(cost_c),
                    Custom4             : spots_n,
                    Custom5             : startingDate_t,
                    Custom6             : currentUserData_c.ud_userId_uid,
                    Custom7             : eventId_uid,
                    Custom8             : couponId_uid,
                    Custom9             : newTicketId_uid,

                    Discount            : (discountPercentage_n * cost_c.c_value_n / 100) // number: 0 -> cost_c.c_value_n
                }
            }).then((ans_o)=>{
                cb_f(ans_o, newTicketId_uid)
            }).catch(err => {
                console.log("Err", err.message)
                errorCb_f(err.message)
            })

        }
    })
}

// server_getPaymentLandingPage_token_f
export const server_getPaymentLandingPage_token_f = ({c_currency_e, langCode_e, currentUserData_c,  cb_f}) => {

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_icredit_GetUrl,
        data_c: {
            GroupPrivateToken       : null,
            Items:[{
                "CatalogNumber"     : "Subscription",
                "Quantity"          : 1,
                "UnitPrice"         : 1,
                "Description"       : `User add credit card`
            }],
            Currency            : c_currency_e,

            RedirectURL         : `${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.standAlong_iframeSuccessMsg)}?msg=${enum_iframeMsg.success_s}`,
            FailRedirectURL     : `${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.standAlong_iframeFailedMsg)}?msg=${enum_iframeMsg.failed_s}`,
            IPNURL              : gv_fun_env.currentProject_e !== enum_projectEnv_s.tq_pro ? gv_urls.icredit_IPN_dev : gv_urls.icredit_IPN,
            IPNFailureURL       : gv_fun_env.currentProject_e !== enum_projectEnv_s.tq_pro ? gv_urls.icredit_IPNFailure_dev : gv_urls.icredit_IPNFailure,

            ExemptVAT           : false,
            SaleType            : enum_saleType_n.token,
            CreateToken         : true,
            MaxPayments         : 1,
            HideItemList        : true,
            DocumentLanguage    : langCode_e,

            CustomerFirstName   : currentUserData_c.ud_name_s,
            CustomerLastName    : currentUserData_c.ud_name_s,
            EmailAddress        : currentUserData_c.ud_email_s,
            // PhoneNumber         : phoneNumber_s === '' ? null : phoneNumber_s,
            // IdNumber            : IdNumber_s === '' ? null : IdNumber_s,

            // Custom1             : qt_questId_uid,
            // Custom2             : agentId_uid,
            // Custom3             : JSON.stringify(cost_c),
            // Custom4             : spots_n,
            // Custom5             : qev_startingDate_t,
            Custom6                : currentUserData_c.ud_userId_uid,
            // Custom7             : eventId_uid,
            // Custom8             : couponId_uid,

            Discount            : 0
        }

    }).then(ans_o => cb_f(ans_o))

}



// server_requestRefund
export const server_requestRefund = (ticket, cb) => {

}

// server_getTicketLink
export const server_getTicketLink = ({ticketId_s, cb_f}) =>{

    let ticketUrl = helper_getTicketUrl(ticketId_s)

    let url =  "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyCagZBk2Vwq7TBZu1JNahNHKCFFHgDIs7w"
    let body = http_getJsonBody_dynamicLinks_o(ticketUrl)

    http_postRequest_fp({url_s: url, jsonBody_o : body, cb_f : cb_f})
}

// server_getTicketShortKey_f
export const server_getTicketShortKey_f = ({ticketShortKeyId_s, cb_f}) => {

    let prefix = ticketShortKeyId_s.substring(0,2)
    let suffix = ticketShortKeyId_s.substring(2)


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_QUESTS_TICKETS.concat(prefix, suffix),
        cb_f    : (data_o) => {
            cb_f(data_o == null ? null : new FB_TicketShortKey(data_o))
        }
    })


    // const ref = REF_REALTIME_PRE_TICKET_SHORT_KEY.child(prefix).child(suffix)
    //
    // realTimeDB_setOnceListener_fp(ref, (ans) => {
    //     if(ans != null){
    //         cb_f(new FB_TicketShortKey(ans))
    //     }else{
    //         cb_f()
    //     }
    // })
}







// ========== others =================

// server_questMold_update_f
export const server_questMold_update_f = (questMold_c, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.QUESTS_MOLDS.concat(questMold_c.qm_questId_uid),
        data_c : questMold_c,
        cb_f : cb_f,
    })
}


// server_questMold_getAll_f
export const server_questMold_getAll_f = (cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.QUESTS_MOLDS,
        cb_f : (questMolds_byQuestId_o) => {
            let questMolds_byQuestId_c = obj_map_fo(questMolds_byQuestId_o, (questMold_o) => {
                return new FB_QuestMold(questMold_o)
            })
            cb_f(questMolds_byQuestId_c)
        },
    })
}


// ========== geoHash =================


// server_questGeoHash_update_fp
export const server_questGeoHash_update_fp = (questId_uid, questGeoHash_c) => {

    http_database_setData_f({
        path_as : http_endPointPath_oa.QUESTS_QUESTS_GEO_HASH.concat(questId_uid),
        data_c: questGeoHash_c
    })
}

// server_questGeoHash_getOnce_fp
export const server_questGeoHash_getOnce_fp = (questId_uid, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.QUESTS_QUESTS_GEO_HASH.concat(questId_uid),
        cb_f : (questGeoHash_o) => {

            cb_f(questGeoHash_o ? new FB_QuestExplore_GeoHash(questGeoHash_o) : null)
        },
    })
}

// server_questGeoHash_withGeoHashFilter_getAll_fp
export const server_questGeoHash_withGeoHashFilter_getAll_fp = (geoHash_s, lastGeoHash_s, cb_f) => {

    http_database_getOnce_f({
        path_as     : http_endPointPath_oa.QUESTS_QUESTS_GEO_HASH,
        query_os    : {
            orderBy     : FB_QuestExplore_GeoHash.qg_l_geoHash_s,
            startAt     : geoHash_s,
            endAt       : lastGeoHash_s,
        },
        cb_f        : (questGeoHash_byQuestId_o) => {

            if(questGeoHash_byQuestId_o){
                let questGeoHash_ao = Object.values(questGeoHash_byQuestId_o)
                cb_f(questGeoHash_ao.map(questGeoHash_o => new FB_QuestExplore_GeoHash(questGeoHash_o)))
            }
        },

    })
}



// ========== discount coupons  =================

// server_checkQuestDiscountCouponCode_fe
export const server_discountCoupons_getAll_f =(questType_e, questId_uid, cb_f) =>{

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(questType_e, questId_uid),
        cb_f : (discountCoupons_byCouponId_o) => {
            let discountCoupons_byCouponId_c = obj_map_fo(discountCoupons_byCouponId_o, (discountCoupon_o) => {
                return new FB_QuestDiscountCoupon(discountCoupon_o)
            })
            cb_f(discountCoupons_byCouponId_c)
        }
    })

}

// server_admin_createNewQuestDiscountCoupons_f
export const server_discountCoupons_new_f =(questType_e, questId_uid, couponCode_s, discountPercentage_n, cb_f) =>{

    http_database_getNewKey_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(questType_e, questId_uid),
        cb_f : (newKey_uid) => {

            let newQuestDiscountCoupon_c = new FB_QuestDiscountCoupon({
                qdc_questType_e             : questType_e,
                qdc_questId_uid             : questId_uid,
                qdc_couponId_uid            : newKey_uid,
                qdc_couponCode_s            : couponCode_s,
                qdc_discountPercentage_n    : discountPercentage_n,
                qdc_history_byTimeStamp_c   : {},
            })


            http_database_setData_f({
                path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(questType_e, questId_uid, newKey_uid),
                data_c : newQuestDiscountCoupon_c,
                cb_f : () => {
                    cb_f(newQuestDiscountCoupon_c)
                }
            })
        }
    })
}

// server_discountCoupons_update_f
export const server_discountCoupons_update_f =(questDiscountCoupon_c, cb_f) =>{

    http_database_updateData_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(questDiscountCoupon_c.qdc_questType_e, questDiscountCoupon_c.qdc_questId_uid, questDiscountCoupon_c.qdc_couponId_uid),
        data_c : questDiscountCoupon_c,
        cb_f : cb_f
    })
}

// server_discountCoupons_get_f
export const server_discountCoupons_getOnce_f = (questType_e, questId_uid, couponCode_s, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(questType_e, questId_uid),
        query_os : {
            orderBy     : FB_QuestDiscountCoupon.qdc_l_couponCode_s,
            equalTo     : couponCode_s,
        },
        cb_f : (questDiscountCoupon_byCouponId_o) => {

            // null
            if(questDiscountCoupon_byCouponId_o == null){
                cb_f()
            }else{
                let couponsCodes_auid = Object.keys(questDiscountCoupon_byCouponId_o)


                if(couponsCodes_auid.length === 0){
                    cb_f()

                    // first QuestDiscountCoupon
                }else{
                    cb_f(new FB_QuestDiscountCoupon(questDiscountCoupon_byCouponId_o[couponsCodes_auid[0]]))
                }
            }
        }
    })
}


// ========== translate =================


// server_translateText_f
export const server_translateText_fp = ({textToTranslate_s, targetLang_e}) => {


    return http_translate_fp({textToTranslate_s: textToTranslate_s, targetLang_e: targetLang_e})
}


// ========== admin =================


// server_admin_createNewQuestDiscountCoupons_f
export const server_admin_createNewQuestDiscountCoupons_f =(newQuestCoupon_o, cb_f) =>{

    http_database_getNewKey_f({
        path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(newQuestCoupon_o.questType_e, newQuestCoupon_o.questId_uid),
        cb_f : (newKey_uid) => {

            let newQuestDiscountCoupon_c = new FB_QuestDiscountCoupon({
                qdc_questType_e             : newQuestCoupon_o.questType_e,
                qdc_questId_uid             : newQuestCoupon_o.questId_uid,
                qdc_couponId_uid            : newKey_uid,
                qdc_couponCode_s            : newQuestCoupon_o.couponCode_s,
                qdc_spots_n                 : 200,
                qdc_active_b                : true,
                qdc_discountPercentage_n    : newQuestCoupon_o.discountPercentage_n,
                qdc_history_byTimeStamp_c   : {},
            })


            http_database_setData_f({
                path_as : http_endPointPath_oa.DATABASE_PRE_QUESTS_DISCOUNT_COUPONS.concat(newQuestCoupon_o.questType_e, newQuestCoupon_o.questId_uid, newKey_uid),
                data_c : newQuestDiscountCoupon_c,
                cb_f : cb_f
            })
        }
    })
}

// server_admin_createNewQuestDiscountCoupons_f
export const server_admin_chargeCreatorMonthlyReport_fp =(adminCreatorMonthlyPaymentSummary_c) =>{

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_chargePayment,
        data_c: adminCreatorMonthlyPaymentSummary_c,
    })

}

// server_admin_updateAllReports_fp
export const server_admin_updateAllReports_fp =(timestamp_n) =>{

    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_runMonthSummaryByDate_s,
        data_c: {timestamp_n},
    })

}